export const STRINGS = {
  TC: {
    // page titles
    pickupNumber: "取餐號碼",
    queueTableSize: "請選擇人數",
    queueTimeSection: "請選擇時段",
    queueDate: "請選擇日期",
    queuePreview: "確認資料",
    queuePersonalInfo: "填寫個人資料",
    queueServiceType: "請選擇服務",
    queueTicketType: "請選擇類型",
    queueSpecialRequest: "請選擇特別安排",
    queueRequestTicketSuccess: "取票成功",
    siteTitle: "活動",
    ticketTitle: "票號詳情",
    siteListTitle: "活動列表",
    // others
    selectSite: "選擇活動",
    requestTicket: "立即取票",
    serverError: "未能完成請求",
    selectTableSize: "請選擇人數",
    selectTimeSection: "請選擇時段",
    selectServiceType: "請選擇服務",
    selectTicketType: "請選擇類型",
    selectDate: "請選擇日期",
    selectSpecialRequest: "請選擇特別安排",
    selectPersonalInfo: "填寫個人資料",
    selectPreview: "資料",
    tableSize: "人數",
    tableType: "服務",
    timeSection: "時段",
    date: "日期",
    ticketType: "類型",
    tags: "特別安排",
    noTag: "沒選擇",
    personalData: "個人資料",
    agree: "同意",
    agreeTnc: "同意條款及細則",
    tnc: "條款及細則",
    emailTitle: "電郵地址*",
    email: "電郵地址",
    emailError: "*您輸入的電郵地址格式錯誤！",
    phoneTitle: "手機號碼*",
    phone: "手機號碼",
    phoneError: "*您輸入的手機號碼格式錯誤！",
    personalInfoTnc: "同意透過個人資料接收優惠並作推廣用途。",
    invalidUrl: "沒有此頁面",
    success: "您已取票成功! ",
    sent: "確認資料已發至 ",
    ok: "確定",
    langButton: "繁",
    requestedTicket: "已經成功取票，請查看%deliveryType%",
    sms: "短訊",
    disabledLabel: "滿",
    redeemed: "已使用",
    returnToSiteDetail: "返回活動主頁",
    smsReminder: "請留意短訊。",
    currentTagSequence: "召集中",
    expand: "展開",
    collapse: "收起",
    preRegistration: "網上預約",
    mobileRequestTicket: "即時手機取票",
    ticketSequence: "現時取票號碼",
    dailyQuota: "本日限額:",
    queueServiceTempUnavailable: "現時該排隊服務 : 沒有開啟",
    quotaRatio: "已派/限額:",
    updateTime: "更新時間:"
  },
  EN: {
    // page titles
    pickupNumber: "Pickup number",
    queueTableSize: "Select number of people",
    queueTimeSection: "Select time section",
    queueDate: "Select date",
    queuePreview: "Confirmation",
    queuePersonalInfo: "Fill in personal info",
    queueServiceType: "Select service",
    queueTicketType: "Select type",
    queueSpecialRequest: "Select special request",
    queueRequestTicketSuccess: "Get ticket success",
    siteTitle: "Event",
    ticketTitle: "Ticket",
    siteListTitle: "Event List",
    // others
    selectSite: "Select Event",
    requestTicket: "Get Ticket",
    serverError: "Server error",
    selectTableSize: "Select Number of People",
    selectTimeSection: "Select Time Section",
    selectServiceType: "Select Service",
    selectDate: "Select Date",
    selectSpecialRequest: "Select Special Request",
    selectPersonalInfo: "Fill in Personal Info",
    selectPreview: "Confirmation",
    tableSize: "Number of People",
    tableType: "Service",
    timeSection: "Time Section",
    date: "Date",
    ticketType: "Type",
    tags: "Special Request",
    noTag: "N/A",
    personalData: "Personal Info",
    agree: "Agree the ",
    agreeTnc: "Agree the terms & conditions",
    tnc: "Terms & Conditions",
    emailTitle: "Email*",
    email: "Email",
    emailError: "You have entered an invalid email!",
    phoneTitle: "Mobile number*",
    phone: "Mobile number",
    phoneError: "You have entered an invalid mobile number!",
    personalInfoTnc: "Agree to receive promotion via the personal info",
    invalidUrl: "Page not found",
    success: "Get ticket successfully! ",
    sent: "Confirmation is sent to ",
    ok: "OK",
    langButton: "ENG",
    requestedTicket: "You have got ticket successfully. Please check %deliveryType%",
    sms: "SMS",
    disabledLabel: "Full",
    redeemed: "Checked in",
    returnToSiteDetail: "Return to event page",
    smsReminder: "Please check SMS",
    currentTagSequence: "Calling Now",
    expand: "Expand",
    collapse: "Collapse",
    preRegistration: "ONLINE BOOKING",
    mobileRequestTicket: "GET A TICKET",
    ticketSequence: "Tickets Distributed",
    dailyQuota: "Today's quota:",
    queueServiceTempUnavailable: "Current queue status : not in service",
    quotaRatio: "Distributed / Quota:",
    updateTime: "Update Time:"
  },
  SC: {
    // page titles
    pickupNumber: "取餐号码",
    queueTableSize: "请选择人数",
    queueTimeSection: "请选择时段",
    queueDate: "请选择日期",
    queuePreview: "确认资料",
    queuePersonalInfo: "填写个人资料",
    queueServiceType: "请选择服务",
    queueTicketType: "请选择类型",
    queueSpecialRequest: "请选择特别安排",
    queueRequestTicketSuccess: "取票成功",
    siteTitle: "活动",
    ticketTitle: "票号详情",
    siteListTitle: "活动列表",
    // others
    selectSite: "选择活动",
    requestTicket: "立即取票",
    serverError: "未能完成请求",
    selectTableSize: "请选择人数",
    selectTimeSection: "请选择时段",
    selectServiceType: "请选择服务",
    selectTicketType: "请选择类型",
    selectDate: "请选择日期",
    selectSpecialRequest: "请选择特别安排",
    selectPersonalInfo: "填写个人资料",
    selectPreview: "资料",
    tableSize: "人数",
    tableType: "服务",
    timeSection: "时段",
    date: "日期",
    ticketType: "类型",
    tags: "特别安排",
    noTag: "没选择",
    personalData: "个人资料",
    agree: "同意",
    agreeTnc: "同意条款及细则",
    tnc: "条款及细则",
    emailTitle: "电邮地址*",
    email: "电邮地址",
    emailError: "*您输入的电邮地址格式错误！",
    phoneTitle: "手机号码*",
    phone: "手机号码",
    phoneError: "*您输入的手机号码格式错误！",
    personalInfoTnc: "同意透过个人资料接收优惠并作推广用途。",
    invalidUrl: "没有此页面",
    success: "您已取票成功! ",
    sent: "确认资料已发至 ",
    ok: "确定",
    langButton: "简",
    requestedTicket: "已经成功取票，请查看%deliveryType%",
    sms: "短讯",
    disabledLabel: "满",
    redeemed: "已使用",
    returnToSiteDetail: "返回活动主页",
    smsReminder: "请留意短讯。",
    currentTagSequence: "召集中",
    expand: "展开",
    collapse: "收起",
    preRegistration: "网上预约",
    mobileRequestTicket: "即时手机取票",
    ticketSequence: "现时取票号码",
    dailyQuota: "本日限额:",
    queueServiceTempUnavailable: "现时该排队服务 : 没有开启",
    quotaRatio: "已派/限额:",
    updateTime: "更新时间:"
  },
  TC_TB: {
    // page titles
    queueTableSize: "請選擇到訪⼈數",
    queueTimeSection: "請選擇到訪時段",
    queueDate: "請選擇到訪⽇期",
    queuePreview: "登記資料",
    queuePersonalInfo: "請輸入電郵地址以作登記",
    queueRequestTicketSuccess: "登記成功",
    // others
    selectTableSize: "請選擇到訪⼈數",
    selectTimeSection: "請選擇到訪時段",
    selectDate: "請選擇到訪日期",
    selectPersonalInfo: "請輸入電郵地址以作登記",
    selectPreview: "登記資料",
    tableSize: "到訪⼈數",
    timeSection: "到訪時段",
    date: "到訪⽇期",
    personalData: "登記電郵地址",
    success: "登記成功！",
    sent: "登記確認資料已發送⾄ "
  },
  EN_TB: {
    // page titles
    queueTableSize: "Select No. of Visitor(s)",
    queueTimeSection: "Select Session of Visit",
    queueDate: "Select Date of Visit",
    queuePreview: "Registration Information",
    queuePersonalInfo: "Fill in Email Address for Registration",
    queueRequestTicketSuccess: "Registration Successful",
    // others
    selectTableSize: "Select No. of Visitor(s)",
    selectTimeSection: "Select Session of Visit",
    selectDate: "Select Date of Visit",
    selectPersonalInfo: "Fill in Email Address for Registration",
    selectPreview: "Registration Information",
    tableSize: "No. of Visitor(s)",
    timeSection: "Session of Visit",
    date: "Date of Visit",
    personalData: "Registration Email",
    success: "Registration Successful! ",
    sent: "A Confirmation Email will be sent to "
  },
  SC_TB: {
    // page titles
    queueTableSize: "请选择到访⼈数",
    queueTimeSection: "请选择到访时段",
    queueDate: "请选择到访⽇期",
    queuePreview: "登记资料",
    queuePersonalInfo: "请输入电邮地址以作登记",
    queueRequestTicketSuccess: "登记成功",
    // others
    selectTableSize: "请选择到访⼈数",
    selectTimeSection: "请选择到访时段",
    selectDate: "请选择到访日期",
    selectPersonalInfo: "请输入电邮地址以作登记",
    selectPreview: "登记资料",
    tableSize: "到访⼈数",
    timeSection: "到访时段",
    date: "到访⽇期",
    personalData: "登记电邮地址",
    success: "登记成功！",
    sent: "登记确认资料已发送⾄ "
  },
  TC_TESTING_CENTRE: {
    siteListTitle: "檢測地點列表",
    selectSite: "選擇地點",
    selectPreview: "請確認以下資料",
    personalData: "個人資料  手提電話",
    smsReminder: "請留意短訊，在指定時間下來排隊，如錯過了指定時間，有可能需要重新排隊。",
    submit: "提交",
    ticketSequence: "現時派籌號碼"
  },
  EN_TESTING_CENTRE: {
    siteListTitle: "Testing Centre List",
    selectSite: "Choose a location",
    queueTimeSection: "Please select your preferred timeslot",
    selectTimeSection: "Please select your preferred timeslot",
    queuePersonalInfo: "Please enter your mobile no. (for receiving SMS)",
    selectPersonalInfo: "Please enter your mobile no. (for receiving SMS)",
    selectPreview: "Please confirm the following information",
    timeSection: "Timeslot",
    personalData: "Mobile No",
    sent: "Your ticket is ready and will be sent to: ",
    smsReminder: "Please watch out the SMS message, and come to the testing centre within your registered timeslot.  If you miss your session, you may need to re-register again.",
    submit: "Submit"
  },
  SC_TESTING_CENTRE: {
    siteListTitle: "检测地点列表",
    selectSite: "选择地点",
    selectPreview: "请确认以下资料",
    personalData: "个人资料  手提电话",
    smsReminder: "请留意短讯，在指定时间下来排队，如错过了指定时间，有可能需要重新排队。",
    submit: "提交",
    ticketSequence: "现时派筹号码"
  },
  TC_MTR_TAXI: {
    currentTagSequence: "現時叫號",
    ticketSequence: "現時取號",
    mobileRequestTicket: "立即取號",
    requestTicket: "立即取號",
    queueServiceType: "選擇⽬的地",
    selectServiceType: "選擇⽬的地",
    queuePersonalInfo: "填寫電郵地址以取號",
    selectPersonalInfo: "填寫電郵地址以取號",
    emailTitle: "電郵地址",
    tableType: "⽬的地",
    preRegistration: "立即取號",
    emailError: "*請提供正確電郵地址"
  },
  EN_MTR_TAXI: {
    currentTagSequence: "Current status",
    ticketSequence: " Current ticket",
    mobileRequestTicket: "Get ticket",
    requestTicket: "Get a ticket",
    queueServiceType: " Select your destination",
    selectServiceType: " Select your destination",
    queuePersonalInfo: "Please provide your email address to get a ticket",
    selectPersonalInfo: "Please provide your email address to get a ticket",
    emailTitle: "Email address",
    tableType: "Your destination",
    preRegistration: "Get ticket",
    emailError: "*Please provide a correct email address"
  },
  SC_MTR_TAXI: {
    currentTagSequence: "现时叫号",
    ticketSequence: "现时取号",
    mobileRequestTicket: "立即取号",
    requestTicket: "立即取号",
    queueServiceType: "选择⽬的地",
    selectServiceType: "选择⽬的地",
    queuePersonalInfo: "填写电邮地址以取号",
    selectPersonalInfo: "填写电邮地址以取号",
    emailTitle: "电邮地址",
    tableType: "⽬的地",
    preRegistration: "立即取号",
    emailError: "*请提供正确电邮地址"
  },
  TC_COUNTER: {
    currentTagSequence: "現時叫號"
  },
  EN_COUNTER: {
    currentTagSequence: "Now Serving"
  },
  SC_COUNTER: {
    currentTagSequence: "现时叫号"
  },
  TC_LEAVE_HOME_SAFE: {
    currentTagSequence: "召集中",
    siteListTitle: "檢測地點列表",
    selectSite: "選擇地點",
    selectPreview: "請確認以下資料",
    personalData: "個人資料  手提電話",
    smsReminder: "請留意短訊，在指定時間下來排隊，如錯過了指定時間，有可能需要重新排隊。",
    submit: "提交",
    ticketSequence: "現時派籌號碼"
  },
  EN_LEAVE_HOME_SAFE: {
    currentTagSequence: "Calling Now",
    siteListTitle: "Testing Centre List",
    selectSite: "Choose a location",
    queueTimeSection: "Please select your preferred timeslot",
    selectTimeSection: "Please select your preferred timeslot",
    queuePersonalInfo: "Please enter your mobile no. (for receiving SMS)",
    selectPersonalInfo: "Please enter your mobile no. (for receiving SMS)",
    selectPreview: "Please confirm the following information",
    timeSection: "Timeslot",
    personalData: "Mobile No",
    sent: "Your ticket is ready and will be sent to: ",
    smsReminder: "Please watch out the SMS message, and come to the testing centre within your registered timeslot.  If you miss your session, you may need to re-register again.",
    submit: "Submit"
  },
  SC_LEAVE_HOME_SAFE: {
    currentTagSequence: "召集中",
    siteListTitle: "检测地点列表",
    selectSite: "选择地点",
    selectPreview: "请确认以下资料",
    personalData: "个人资料  手提电话",
    smsReminder: "请留意短讯，在指定时间下来排队，如错过了指定时间，有可能需要重新排队。",
    submit: "提交",
    ticketSequence: "现时派筹号码"
  },
}